// extracted by mini-css-extract-plugin
export default {"DashboardDropzone":"DashboardDropzone","DashboardDropzone--hover":"DashboardDropzone--hover"};